import { Link } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import {
  HandleStatus,
  Prefectures,
  Status,
} from "../../../assets/data/Constants";
import TkModal from "../../../components/atoms/TkModal";
import TkTitle from "../../../components/atoms/TkTitle";
import TkTable from "../../../components/atoms/TkTable";
import TkFakeTable from "../../../components/molecules/TkFakeTable";
import TkButton from "../../../components/atoms/TkButton";
import { TkGetCode } from "../../../utils/TkGetCode";
import { ITkFakeTableLineProps } from "../../../type/componentsType/TkFakeTableLine";
import { ProcedureInfoList } from "../../../type/apiType/IAPI_APP017";
import { LatestProcedureInfoList } from "../../../type/apiType/IAPI_APP001";
import "./_style.scss";
import { useContext } from "react";
import { GlobalContext } from "../../../context/globalContext";

/**
 * 契約者・住所・担当者　表示
 * @param {any} props.item APIレスポンス
 * @return TopInfo
 */
const TopInfo = (props: any) => {
  const { item } = props;
  const { state } = useContext(GlobalContext);

  return (
    <Box className="SCRC020001Components">
      <Box className="topInfo">
        <Typography>
          <span>契約者</span>　{item?.contractorNo}:{item?.corpName}
        </Typography>
        <Typography>
          <span>住所</span>　{TkGetCode(Prefectures, item?.prefecture)}
          {item.addressCity}
          {item.addressOthers}
        </Typography>
        <Typography>
          <span>担当者</span>　
          {!state.authInfo?.contractApprovalDate ? (
            <label>
              {`${item.contactManagerName}（${item?.contactEmail}）`}
            </label>
          ) : (
            <Link to="/SCRC040106">
              {`${item.contactManagerName}（${item?.contactEmail}）`}
            </Link>
          )}
        </Typography>
      </Box>
    </Box>
  );
};

/**
 * 手続きお知らせモーダル
 * @param {any} props.item レスポンスデータ
 * @param {boolean} props.open true:開く false:閉じる
 * @param {any} props.button 対応ボタン
 * @param {any} props.onClose 「閉じる」ボタン押下時のイベント
 * @return ProcedureModal
 */
const ProcedureModal = (props: any) => {
  const { item, button, open, onClose } = props;

  const tableList: ITkFakeTableLineProps[] = [
    {
      title: "対応期日",
      keyword: "dueDate",
      type: "text",
      text: item?.dueDate,
    },
    {
      title: "関連手続き",
      keyword: "procedure",
      type: "text",
      text: item?.businessTypeShortName,
    },
  ];

  const bodyList = [
    [
      {
        children: (
          <Typography sx={{ whiteSpace: "pre-line" }}>
            {item?.taskDetail}
          </Typography>
        ),
      },
    ],
  ];

  return (
    <TkModal className="SCRC020001Components" open={open}>
      <Box className="modal">
        <TkTitle>{item?.procedureTitle}</TkTitle>
        <TkFakeTable list={tableList} ruleSchema={{}} showButton={false} />

        <TkTable headList={[{ headTitle: "依頼内容" }]} bodyList={bodyList} />

        <Box className="button">
          <TkButton onClick={onClose}>閉じる</TkButton>
          {button}
        </Box>
      </Box>
    </TkModal>
  );
};

/**
 * 対応　ボタン
 * @param props.item APIレスポンス
 * @return HandleButton
 * @param props
 */
const HandleButton = (props: {
  item?: ProcedureInfoList & LatestProcedureInfoList;
  onClick?: any;
}) => {
  const { item, onClick } = props;

  let buttonName;

  switch (item?.handleStatus) {
    case HandleStatus["未対応"]:
    case HandleStatus["手続中"]:
      if (item.businessType === "JOB-45") {
        buttonName = "確認";
      } else if (item.businessType === "JOB-10") {
        buttonName = "完了報告";
      } else if (
        item.businessType === "JOB-01" ||
        item.businessType === "JOB-11" ||
        item.businessType === "JOB-21" ||
        item.businessType === "JOB-28" ||
        item.businessType === "JOB-29" ||
        item.businessType === "JOB-30"
      ) {
        buttonName = "手続きへ";
      } else if (
        item.latestApplyStatus === Status["届出待ち"] &&
        item.applyId
      ) {
        buttonName = "手続きへ,削除";
      } else if (
        item.latestApplyStatus === Status["差戻し一時保存"] &&
        item.applyId
      ) {
        buttonName = "手続きへ,取下";
      } else if (
        item.executionKbn === "2" ||
        item.executionKbn === "3" ||
        item.executionKbn === "4" ||
        ((item.businessType === "JOB-27" || item.businessType === "JOB-32") &&
          item.executionKbn === "0")
      ) {
        buttonName = "手続きへ,不要";
      } else if (
        ["JOB-02", "JOB-18", "JOB-33"].includes(item.businessType ?? "") &&
        item.procedureTitle?.includes("引継ぎコードのお知らせ")
      ) {
        buttonName = "完了";
      } else {
        buttonName = "手続きへ";
      }
      break;

    case HandleStatus["不要"]:
      buttonName = "戻す";
      break;

    case HandleStatus["完了"]:
      if (item.businessType === "JOB-79") {
        buttonName = "確認";
      } else if (
        item.businessType === "JOB-11" &&
        item.latestApplyStatus === Status["処理完了"] &&
        item.applyId &&
        item.resubmitButtonDisplayFlg === "1"
      ) {
        buttonName = "確認,取下";
      } else if (item.businessType === "JOB-80") {
        buttonName = null;
      } else if (!item.applyId) {
        buttonName = null;
      } else if (item.businessType !== "JOB-45") {
        buttonName = "確認";
      }
      break;

    case HandleStatus["取下"]:
      buttonName = "確認";
      break;

    case HandleStatus["削除"]:
      buttonName = null;
      break;

    case HandleStatus["差戻し"]:
      buttonName = "確認";
      break;
  }

  const handleClick = (name: any) => {
    onClick && onClick(name);
  };

  return buttonName ? (
    <Box className="SCRC020001Components">
      <Box className={`buttonGroup`}>
        {buttonName.split(",").map((item, index) => (
          <TkButton
            className={`${item === "戻す" && "buttonGoToRight"}`}
            key={index}
            onClick={() => handleClick(item)}
          >
            {item}
          </TkButton>
        ))}
      </Box>
    </Box>
  ) : (
    <></>
  );
};

export { TopInfo, ProcedureModal, HandleButton };
